<div class="t12-box" cdkOverlayOrigin #origin="cdkOverlayOrigin"
     [class.t12-locked]="locked"
     [class.t12-open]="pickerOpen"
     [class.t12-empty-box]="highlightEmpty && !hour && !minute">
  <input #hourEl class="t12-seg" type="text" inputmode="numeric" maxlength="2" placeholder="--"
         [value]="hour" [readonly]="locked" aria-label="Hora"
         (focus)="selectAll($event)"
         (input)="onSegmentInput($event, 'hour')"
         (keydown)="onSegmentKeydown($event, 'hour')"
         (blur)="onSegmentBlur('hour')">
  <span class="t12-sep">:</span>
  <input #minuteEl class="t12-seg" type="text" inputmode="numeric" maxlength="2" placeholder="--"
         [value]="minute" [readonly]="locked" aria-label="Minutos"
         (focus)="selectAll($event)"
         (input)="onSegmentInput($event, 'minute')"
         (keydown)="onSegmentKeydown($event, 'minute')"
         (blur)="onSegmentBlur('minute')">
  <button type="button" class="t12-period" [class.t12-empty]="!period" [class.t12-missing]="missingPeriod"
          [disabled]="locked" aria-label="AM / PM"
          [matTooltip]="missingPeriod ? 'Escriba A o P para indicar AM o PM' : ''"
          (click)="togglePeriod()"
          (keydown)="onPeriodKeydown($event)">
    {{ period || '--' }}
  </button>
  <button type="button" class="t12-clock" [disabled]="locked" aria-label="Seleccionar hora"
          (click)="togglePicker()">
    <mat-icon>schedule</mat-icon>
  </button>
</div>

<ng-template cdkConnectedOverlay
             [cdkConnectedOverlayOrigin]="origin"
             [cdkConnectedOverlayOpen]="pickerOpen"
             [cdkConnectedOverlayPositions]="pickerPositions"
             [cdkConnectedOverlayHasBackdrop]="true"
             cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
             (backdropClick)="closePicker()"
             (detach)="closePicker()"
             (attach)="onPickerAttach()">
  <div #panelEl class="t12-panel" (keydown.escape)="closePicker()">
    <div class="t12-col" aria-label="Hora">
      <button type="button" class="t12-opt" *ngFor="let h of hours"
              [class.t12-opt--selected]="h === hour" (click)="pick('hour', h)">{{ h }}</button>
    </div>
    <div class="t12-col" aria-label="Minutos">
      <button type="button" class="t12-opt" *ngFor="let m of minutes"
              [class.t12-opt--selected]="m === minute" (click)="pick('minute', m)">{{ m }}</button>
    </div>
    <div class="t12-col t12-col--period" aria-label="AM / PM">
      <button type="button" class="t12-opt" *ngFor="let p of periods"
              [class.t12-opt--selected]="p === period" (click)="pick('period', p)">{{ p }}</button>
    </div>
  </div>
</ng-template>
